module.exports = __webpack_public_path__ + "media/images/commas-7d79b750f9443184f85d6cb04eee6ee6.webp";